import { render } from "./BadgeDanger.vue?vue&type=template&id=70ad2eb0"
import script from "./BadgeDanger.vue?vue&type=script&lang=js"
export * from "./BadgeDanger.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__